import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { AdSpacePhotoCommentInterface } from '../../../interfaces/interfaces';

export const getAdSpacePhotoCommentColumns = (
  setCommentToDelete: (comment: AdSpacePhotoCommentInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setCommentToUpdate: (comment: AdSpacePhotoCommentInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'adSpacePhotoId', headerName: 'Ad Space Photo ID', width: 150 },
  { field: 'comment', headerName: 'Comment', width: 300 },
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 150 },
  { field: 'updated_at', headerName: 'Updated', width: 150 },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setCommentToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setCommentToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];